import { getColumnsByNames, } from './all-top10-columns-config';

export const topDDShieldHitsConfig = getColumnsByNames([
    { name: 'dst', width: '40%', header: 'IP' },
    { name: 'count', width: '29%' }
]);